module.exports = __webpack_public_path__ + "img/name-icon.6f0d9650.svg";